import { render, staticRenderFns } from "./view-endpoint-modal.vue?vue&type=template&id=1d0634b5&scoped=true"
import script from "./view-endpoint-modal.vue?vue&type=script&lang=js"
export * from "./view-endpoint-modal.vue?vue&type=script&lang=js"
import style0 from "./view-endpoint-modal.vue?vue&type=style&index=0&id=1d0634b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0634b5",
  null
  
)

export default component.exports